// src/pages/Signup.jsx
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useApp } from '../context/AppContext'
import { PasswordInput } from '../components/UI'
import LanguageSwitcher from '../components/LanguageSwitcher'

export default function Signup() {
  const { register } = useApp()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [name,     setName]     = useState('')
  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [confirm,  setConfirm]  = useState('')
  const [error,    setError]    = useState('')
  const [info,     setInfo]     = useState('')
  const [loading,  setLoading]  = useState(false)

  const validate = () => {
    if (!name.trim())         return t('signup.error_name')
    if (!email.trim())        return t('signup.error_email')
    if (!password)            return t('signup.error_password')
    if (password.length < 6)  return t('signup.error_min_password')
    if (password !== confirm)  return t('signup.error_match')
    return ''
  }

  const submit = async () => {
    setError(''); setInfo('')
    const err = validate()
    if (err) { setError(err); return }
    setLoading(true)
    const { error: regErr, needsConfirmation } = await register(name, email.trim().toLowerCase(), password)
    setLoading(false)
    if (regErr) {
      setError(regErr.toLowerCase().includes('already registered') ? t('signup.error_exists') : regErr)
      return
    }
    if (needsConfirmation) setInfo(t('signup.check_email'))
    else navigate('/transactions', { replace: true })
  }

  return (
    <div className="login-page">
      <div className="login-box">
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <LanguageSwitcher variant="login" />
        </div>
        <div className="login-logo">
          <div className="logo-icon"><i className="ti ti-wallet" aria-hidden="true" /></div>
          <div>
            <div className="logo-name">{t('app.name')}</div>
            <div className="logo-sub">{t('app.tagline')}</div>
          </div>
        </div>
        <div className="login-title">{t('signup.title')}</div>
        <div className="login-sub">{t('signup.subtitle')}</div>
        {error && <div className="login-err"><i className="ti ti-alert-circle" aria-hidden="true" />{error}</div>}
        {info  && <div className="login-err" style={{ background: 'var(--green-50)', color: 'var(--green-600)', borderColor: '#9fd8b8' }}><i className="ti ti-mail-check" aria-hidden="true" />{info}</div>}
        {!info && (<>
          <div className="login-field">
            <label htmlFor="su-name">{t('signup.full_name')}</label>
            <input id="su-name" className="input" type="text" value={name} onChange={e => setName(e.target.value)} placeholder={t('signup.full_name_placeholder')} autoComplete="name" autoFocus />
          </div>
          <div className="login-field">
            <label htmlFor="su-email">{t('signup.email')}</label>
            <input id="su-email" className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" autoComplete="email" />
          </div>
          <div className="login-field">
            <label htmlFor="su-pass">{t('signup.password')}</label>
            <PasswordInput id="su-pass" value={password} onChange={setPassword} placeholder={t('signup.password_placeholder')} />
          </div>
          <div className="login-field">
            <label htmlFor="su-confirm">{t('signup.confirm_password')}</label>
            <PasswordInput id="su-confirm" value={confirm} onChange={setConfirm} placeholder={t('signup.confirm_placeholder')} onKeyDown={e => e.key === 'Enter' && submit()} />
          </div>
          <button className="login-btn" onClick={submit} disabled={loading}>
            {loading
              ? <><i className="ti ti-loader-2" aria-hidden="true" style={{ animation: 'spin 1s linear infinite' }} /> {t('signup.creating')}</>
              : <><i className="ti ti-user-plus" aria-hidden="true" /> {t('signup.create_account')}</>
            }
          </button>
        </>)}
        <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--gray-600)', marginTop: 18 }}>
          {t('signup.have_account')}{' '}
          <Link to="/login" style={{ color: 'var(--brand-600)', fontWeight: 600, textDecoration: 'none' }}>{t('signup.sign_in_link')}</Link>
        </p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}
